import { render } from "./UtilityDetailList.vue?vue&type=template&id=19044792&ts=true"
import script from "./UtilityDetailList.vue?vue&type=script&lang=ts"
export * from "./UtilityDetailList.vue?vue&type=script&lang=ts"

import "./UtilityDetailList.vue?vue&type=style&index=0&id=19044792&lang=scss"

import exportComponent from "/home/runner/work/billygrossman.com/billygrossman.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__